<template>
  <div
    id="menuShow"
    @mouseleave="onMouseLeave"
    :class="[open ? 'draw-show' : 'draw-hide']"
    class="nav-wrapper position-fixed full-y"
  >
    <Search />
    <div class="menu-category full-y padding-left-10">
      <MenuLogo />
      <div class="menu-list">
        <div class="padding-y-6" :key="item.id" v-for="(item, index) in menus">
          <MenuItem
            @click="setActiveIndex(index)"
            :active="index === activeIndex"
            :title="item.name"
            :selectedIcon="item.selectedIcon"
            :unselectedIcon="item.unselectedIcon"
            :id="index === 0 ? 'commonMenu' : ''"
          />
          <div v-if="keyWords" class="sub-menu search-menu position-absolute">
            <div v-if="resultList.length" class="padding-x-15">
              <div v-for="sub in resultList" :key="sub.id">
                <Title :path="sub.path" :title="sub.name" />
                <div class="flex-start flex-wrap">
                  <NavLink
                    :path="grand.path"
                    v-for="grand in sub.children"
                    :title="grand.name"
                    :key="grand.id"
                    :item="grand"
                  />
                </div>
              </div>
            </div>
            <div v-else class="flex-center margin-top-40 color-999">未搜索到相关菜单</div>
          </div>
          <template v-else>
            <div v-show="index === activeIndex" class="sub-menu position-absolute">
              <div class="padding-x-15">
                <div v-for="sub in item.children" :key="sub.id">
                  <Title :path="sub.path" :title="sub.name" />
                  <div class="flex-start flex-wrap margin-left-5">
                    <NavLink
                      :path="grand.path"
                      v-for="grand in sub.children"
                      :title="grand.name"
                      :key="grand.id"
                      :item="grand"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
import { onMounted, computed, provide } from '@vue/composition-api';
import store from '@/store';
import MenuItem from './menu-item.vue';
import Search from './search.vue';
import Title from './group-title.vue';
import NavLink from './nav-link.vue';
import { useKeyDown } from '@/hooks';
import useDrawMenu from '../hooks/useDrawMenu.js';
import MenuLogo from './menu-logo.vue';
import { getStore } from '@/util/store';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const open = computed(() => store.state.common.open);
  // store.dispatch('GetMenu')
  useKeyDown(192, () => {
    store.commit('SET_OPEN', !open.value);
  });
  useKeyDown(27, () => {
    store.commit('SET_OPEN', false);
  });
  const {
    menus,
    activeIndex,
    setActiveIndex,
    keyWords,
    setKeyWords,
    resultList
  } = useDrawMenu();
  const onMouseLeave = () => {
    const flag = getStore({
      name: 'firstVisitEditor'
    });
    if (!flag) {
      return;
    }
    store.commit('SET_OPEN', false);
  };
  provide('keyWords', {
    keyWords,
    setKeyWords
  });
  onMounted(() => {});
  return {
    open,
    menus,
    activeIndex,
    setActiveIndex,
    keyWords,
    resultList,
    onMouseLeave
  };
};
__sfc_main.components = Object.assign({
  Search,
  MenuLogo,
  MenuItem,
  Title,
  NavLink
}, __sfc_main.components);
export default __sfc_main;
</script>
<style scoped lang="scss">
  $width: 410px;
  $leftWidth: 130px;
  $logoH: 50px;

  .nav-wrapper {
    background-color: #eef5ff;
    ::-webkit-scrollbar {
      display: none;
    }

    left: 0;
    top: 0;
    width: $width;
    box-shadow: 9px 0px 8px 0px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    transform: translateX(-100%) scale(0.98);
    transition: transform 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);
    transform-origin: left top;

    &.draw-show {
      transform: translateX(0) scale(1);
    }

    &.draw-hide {
      transform: translateX(-100%) scale(0.98);
    }
  }

  .menu-category {
    width: $leftWidth;
    background: #eef5ff;
    box-sizing: border-box;
  }

  .menu-list {
    height: calc(100% - $logoH);
    overflow: auto;
    box-sizing: border-box;
  }

  .sub-menu {
    padding-top: 8px;
    top: $logoH;
    height: calc(100% - $logoH - 8px);
    left: $leftWidth;
    width: calc($width - $leftWidth);
    overflow: auto;
    border-radius: 0px 0px 0px 16px;
    background-color: #fff;
  }

  .search-menu {
    z-index: 100;
    background-color: #fff;
  }
</style>
